import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=13fbf323&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports